const getRandomString = () => Math.random().toString(36).substring(3);

export default getRandomString;
